<template>
  <div class="loader-background" v-if="visible">
    <div class="progress-bar" :style="{ height: height + '%'}">
      <div class="percentage" :class="percentageClass">{{ percentage }}%</div>
    </div>
  </div>
</template>

<script>

function incrementSafely(percentage, increment) {
  return Math.min(percentage + increment, 100);
}

function randomize(number) {
  return number + Math.floor(Math.random() * 10);
}

export default {
  name: 'ProgressLoader',
  props: {
    stepInterval: {
      type: Number,
      default: 2000,
    },
  },
  data() {
    return {
      percentage: 0,
      interval: null,
      visible: false,
      stopped: false,
      resetting: false,
    };
  },
  computed: {
    height() {
      if (this.percentage === 0) {
        return 2;
      }
      return this.percentage;
    },
    increment() {
      if (this.stopped) {
        // We were told to stop so let's hurry up!
        return 100 - this.percentage;
      }

      if (this.percentage >= 80) {
        // The process is still running but we're reaching 100%. Let's slow down!
        return 1;
      }

      return randomize(10);
    },
    percentageClass() {
      if (this.percentage === 0) {
        return 'above-line';
      }
      return '';
    },
  },
  methods: {
    start() {
      this.visible = true;
      this.scheduleProgress(this.stepInterval);
    },
    stop() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.scheduleProgress(100);
      this.stopped = true;
    },
    incrementPercentage() {
      if (this.percentage === 100) {
        if (!this.resetting) {
          this.resetting = true;
          setTimeout(this.reset.bind(this), 1000);
        }
      } else {
        this.percentage = incrementSafely(this.percentage, this.increment);
      }
    },
    reset() {
      clearInterval(this.interval);
      this.visible = false;
      this.percentage = 0;
      this.interval = null;
      this.resetting = false;
      this.$emit('stopped');
    },
    scheduleProgress() {
      this.interval = setInterval(this.incrementPercentage.bind(this), this.stepInterval);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../node_modules/base-ui/src/scss/riseup-colors';

  .loader-background {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;

    .progress-bar {
      width: 100%;
      height: 0%;
      background-color: $riseup_blue;
      position: relative;
      transition: height 0.5s linear;

      .percentage {
        font-size: 36px;
        font-family: SimplerProBold;
      }

      .percentage {
        color: $riseup_white;
        margin-top: 22px;
        text-align: center;
      }

      .percentage.above-line {
        position: absolute;
        width: 100%;
        top: -60px;
        color: $riseup_blue;
        text-align: center;
      }
    }
  }

</style>
